import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
  // https://router.vuejs.org/api/interfaces/routeroptions.html#routes
  routes: (_routes) => [
    //
    // Login
    //
    {
      name: 'login',
      path: '/login',
      meta: {
        open: true
      },
      component: () => import('~/pages/Login.vue')
    },
    //
    // Home
    //
    {
      name: 'home',
      path: '/',
      component: () => import('~/pages/Home.vue')
    },
    //
    // Startups / Companies
    //
    {
      name: 'startups-index',
      path: '/startups',
      component: () => import('~/pages/startups/Startups.vue')
    },
    {
      name: 'startups-bulk-update',
      path: '/startups/update',
      component: () => import('~/pages/startups/StartupsBulkUpdate.vue')
    },
    {
      name: 'startups-csv-update',
      path: '/startups/csv-update',
      component: () => import('~/pages/startups/StartupsCsvUpdate.vue')
    },
    {
      name: 'company',
      path: '/startups/:slug',
      component: () => import('~/pages/startups/Company.vue'),
      children: [
        {
          name: 'company-view',
          path: '',
          component: () => import('~/pages/startups/CompanyView.vue')
        },
        {
          name: 'company-edit',
          path: 'edit',
          component: () => import('~/pages/startups/CompanyEdit.vue')
        }
      ]
    },
    //
    // Investors
    //
    {
      name: 'investors-index',
      path: '/investors',
      component: () => import('~/pages/investors/Investors.vue'),
    },
    {
      name: 'scout',
      path: '/scout',
      component: () => import('~/pages/scout/Scout.vue')
    },
    {
      name: 'investor-view',
      path: '/investors/:id',
      component: () => import('~/pages/investors/InvestorView.vue')
    },
    //
    // People / Contacts
    //
    {
      name: 'people-index',
      path: '/people',
      component: () => import('~/pages/people/People.vue')
    },
    {
      name: 'contact',
      path: '/people/:slug',
      component: () => import('~/pages/people/Contact.vue'),
      children: [
        {
          name: 'contact-view',
          path: '',
          component: () => import('~/pages/people/ContactView.vue')
        },
        {
          name: 'contact-edit',
          path: 'edit',
          component: () => import('~/pages/people/ContactEdit.vue')
        }
      ]
    },
    //
    // News
    //
    {
      name: 'news-index',
      path: '/news',
      component: () => import('~/pages/news/News.vue')
    },
    {
      name: 'news-admin',
      path: '/news/admin',
      component: () => import('~/pages/news/NewsAdmin.vue')
    },
    //
    // Programs
    //
    {
      name: 'programs-index',
      path: '/programs',
      component: () => import('~/pages/programs/Programs.vue')
    },
    {
      name: 'program-view',
      path: '/programs/:slug',
      component: () => import('~/pages/programs/Program.vue'),
      children: [
        {
          name: 'cohort-view',
          path: ':cohort_slug',
          component: () => import('~/pages/programs/Cohort.vue')
        }
      ]
    },
    //
    // Profile / Preferences
    //
    {
      name: 'profile',
      path: '/profile',
      component: () => import('~/pages/Profile.vue')
    },
    {
      name: 'preferences',
      path: '/preferences',
      component: () => import('~/pages/Preferences.vue')
    },
    //
    // Form Tokens
    //
    {
      name: 'form-tokens',
      path: '/forms',
      component: () => import('~/pages/tokens/TokenSelect.vue'),
      children: [
        {
          name: 'form-token-request',
          path: ':form',
          component: () => import('~/pages/tokens/TokenRequest.vue')
        }
      ]
    },
    //
    //
    // Wheel
    //
    {
      name: 'wheel',
      path: '/wheel',
      component: () => import('~/pages/admin/Wheel.vue')
    },
    //
    // Insights
    //
    {
      name: 'insight-add',
      path: '/insights/add',
      component: () => import('~/pages/insights/InsightAdd.vue')
    },
    {
      name: 'insights-index',
      path: '/insights',
      component: () => import('~/pages/insights/InsightIndex.vue'),
      children: [
        {
          name: 'insight-view',
          path: ':slug',
          component: () => import('~/pages/insights/InsightView.vue')
        }
      ]
    },
    {
      name: 'insight-edit',
      path: '/insights/:slug/edit',
      component: () => import('~/pages/insights/InsightEdit.vue')
    // },
    // -------
    // Wiki --
    // -------
    // {
    //   path: "/wiki",
    //   name: "wiki-index",
    //   component: () => import("~/pages/wiki/Wikis.vue")
    }, {
      path: "/wiki/:wiki/",
      name: "wiki-home",
      component: () => import("~/pages/wiki/WikiPage.vue")
    }, {
      path: "/wiki/:wiki/:path+",
      name: "wiki-page",
      component: () => import("~/pages/wiki/WikiPage.vue")
    },
    //
    // Service Logs
    //
    {
      name: 'service-logs',
      path: '/logs',
      component: () => import('~/pages/ServiceLogs.vue')
    },
    //
    // Chatbot
    //
    {
      name: 'chatbots-index',
      path: '/chatbots',
      component: () => import('~/pages/chatbots/ChatbotIndex.vue'),
      children: [
        {
          name: 'chatbot-view',
          path: ':slug',
          component: () => import('~/pages/chatbots/ChatbotView.vue')
        }
      ]
    },
    //
    // Collections
    //
    {
      name: 'collections',
      path: '/collections',
      component: () => import('~/pages/collections/Collections.vue')
    },
    {
      name: 'collections-view',
      path: '/collections/:slug',
      component: () => import('~/pages/collections/Collection.vue')
    },
    //
    // Onboarding
    //
    {
      name: 'onboarding-index',
      path: '/onboarding',
      component: () => import('~/pages/onboarding/Onboarding.vue')
    },
    {
      name: 'onboarding-update',
      path: '/onboarding/:slug',
      component: () => import('~/pages/onboarding/OnboardingUpdate.vue')
    },
    //
    // Release Notes
    //
    {
      name: 'release-notes',
      path: '/release-notes',
      component: () => import('~/pages/ReleaseNotes.vue')
    }
  ]
}
